import { checkCategoryCertificateStatus } from './checkCategoryCertificateStatus/index'
import { uploadCategoryCertificate } from './uploadCategoryCertificate/index'

export const CostCenterPersonService = {
  checkCategoryCertificateStatus,
  uploadCategoryCertificate
}